import request from '../axios/axios';

/**
 * get请求模板
 */
export const getdemo = () => {
    return request.post('/use', {});
};
/**
 * post请求模板
 */
export const postdemo = () => {
    return request.post('/index', {});
};

/**
 *  手机验证码发送
 */
export const sendSmsCode = (params: any) => {
    return request.post('/common/sms/send', params);
};

/**
 * 登录接口
 */
export const Login = (params: any) => {
    return request.post('/user/login', params);
};

/**
 * 退出登录接口
 */
export const Logout = (params: any) => {
    return request.post('/user/logout', params);
};

/**
 * 注销账号接口
 */
export const DeleteAccount = (params: any) => {
    return request.post('/user/delete', params);
};

/**
 *  /user/dashboard/data  首页数据
 */
export const dashboard_data = (params: any) => {
    return request.post('/user/dashboard/data', params);
};
/**
 *  公告列表 /common/announcement/list
 */
export const common_announcement_list = (params: any) => {
    return request.post('/common/announcement/list', params);
};


/**\
 *我要推广------------------------------------------
 */

/**
 *  我要推广-活动列表 /promotion/activity/list
 */

export const activity_list = (params: any) => {
    return request.post('/promotion/activity/list', params);
};
/**
 *  我要推广-活动详情 /promotion/activity/detail
 */
export const activity_detail = (params: any) => {
    return request.post('/promotion/activity/detail', params);
};
/**
 *  我要推广位列表 /promotion/position/list
 */
export const promotion_position_list = (params: any) => {
    return request.post('/promotion/position/list', params);
};
/**
 *  我要推广位新增 /promotion/position/add
 */

export const promotion_position_add = (params: any) => {
    return request.post('/promotion/position/add', params);
};
/**
 *  我要推广位修改 或者删除 /promotion/position/edit
 */
export const promotion_position_edit = (params: any) => {
    return request.post('/promotion/position/edit', params);
};

/**
 *  /promotion/activity/promote 推广活动
 */

export const promotion_activity_promote = (params: any) => {
    return request.post('/promotion/activity/promote', params);
};

/**
 * 结算数据
 * /user/settle/data
 */

export const user_settle_data = (params: any) => {
    return request.post('/user/settle/data', params);
};
/**
 * /user/settle/orders 结算订单列表
 */

export const user_settle_orders = (params: any) => {
    return request.post('/user/settle/orders', params);
};

/**
 * 推广学院 列表 /promotion/course/list
 */

export const promotion_course_list = (params: any) => {
    return request.post('/promotion/course/list', params);
};

/**
 * 推广学院 详情 /promotion/course/detail
 */

export const promotion_course_detail = (params: any) => {
    return request.post('/promotion/course/detail', params);
};
/**
 * 推广学院 faqs列表 /promotion/faq/list
 */
export const promotion_faqs_list = (params: any) => {
    return request.post('/promotion/faq/list', params);
};

// --------------------------------------------

/**推广数
 *  /user/order/data
 * 据 */

/**
 * 订单数据
 * @param params
 * @returns
 */
export const user_order_data = (params: any) => {
    return request.post('/user/order/data', params);
};
/**
 * 结算数据 /user/settle/data
 * /user/order/settlement
 */
export const user_order_settlement = (params: any) => {
    return request.post('/user/order/settlement', params);
};

/**
 *  公共接口 类型配置 /common/type/config
 */
export const type_config = (params: any) => {
    return request.post('/common/type/config', params);
};
/**
 *  公共接口  文件上传  /common/upload
 */
export const common_upload = (params: any) => {
    return request.post('/common/upload', params, { ablen: 1 });
};
/**
 *  公共接口 媒体类型 /common/media/type
 */
export const common_media_type = (params: any) => {
    return request.post('/common/media/type', params);
};


/**
 *  个人中心-修改用户信息 /user/info/modify
 */
export const user_info_modify = (params: any) => {
    return request.post('/user/info/modify', params);
};

/**
 *  个人中心-认证 /user/auth/commit
 */
export const user_auth_commit = (params: any) => {
    return request.post('/user/auth/commit', params);
};

/**
 *  个人中心-实人认证 /user/auth/verify
 */
export const user_auth_verify = (params: any) => {
    return request.post('/user/auth/verify', params);
};

/**
 *  个人中心-获取用户信息 /user/info
 */
export const user_info = (params: any) => {
    return request.post('/user/info', params);
};

/**
 *  个人中心-修改密码 /user/password/change
 */
export const changepwd = (params: any) => {
    return request.post('/user/password/change', params);
};

/**
 *  消息列表 /msg/list
 */

export const msg_list = (params: any) => {
    return request.post('/msg/list', params);
};
/**
 *  获取 未读信息 /msg/unreadnum
 * 
 */
export const getUnreadMsg = (params: any) => {
    return request.post('/msg/unreadnum', params);
}
/**
 *  消息详情 /msg/detail
 */
export const msg_detail = (params: any) => {
    return request.post('/msg/detail', params);
};

/**
 *  消息已读 /msg/read
 */
export const msg_read = (params: any) => {
    return request.post('/msg/read', params);
};

/**
 *  个人中心----------
 */

/**
 * 配置列表  /common/config/list
 */
export const common_config_list = (params: any) => {
    return request.post('/common/config/list', params);
};

/**
 * 推广管理--------------------------------
 */

/**
 *  媒体列表
 * /promotion/media/list
 */

export const promotion_media_list = (params: any) => {
    return request.post('/promotion/media/list', params);
};

/**
 * 新增媒体
 * /promotion/media/add
 */
export const promotion_media_add = (params: any) => {
    return request.post('/promotion/media/add', params);
};

/**
 * 修改媒体 or 删除媒体
 * /promotion/media/modify
 */
export const promotion_media_edit = (params: any) => {
    return request.post('/promotion/media/edit', params);
};

/**
 * 推广管理--------------------------------
 */
